import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AddHotelComponent} from './add-hotel/add-hotel.component';
import {AdminComponent} from './admin.component';
import {RouterModule, Routes} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GooglePlacesDirective} from './add-hotel/google-places.directive';
import {PartialsModule} from '../../partials/partials.module';
import {TranslateModule} from '@ngx-translate/core';
import {MatAutocompleteModule, MatInputModule, MatTooltipModule} from '@angular/material';

const routes: Routes = [
  {path: '', component: AddHotelComponent},
];

@NgModule({
  declarations: [
    AdminComponent,
    AddHotelComponent,
    GooglePlacesDirective
  ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        RouterModule,
        FormsModule,
        PartialsModule,
        TranslateModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatInputModule,
        MatTooltipModule
    ]
})
export class AdminModule {
}
